import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  spacing?: 'normal' | 'tight' | 'loose';
}

const spacingMap = {
  tight: 'py-12 md:py-16',
  normal: 'py-16 md:py-24',
  loose: 'py-24 md:py-32',
};

export function Section({
  children,
  className,
  id,
  spacing = 'normal',
}: SectionProps) {
  return (
    <section
      id={id}
      className={cn('relative overflow-hidden', spacingMap[spacing], className)}
    >
      {children}
    </section>
  );
}
